import React, { useRef, useState } from 'react';
import { FocusTrap } from 'focus-trap-react';
import PropTypes from 'prop-types';

import { accessibleOnClick } from '../../helpers';

import { Footer, Group } from './components';
import styles from './SiteNavigation.module.less';

const SiteNavigation = ({
  title,
  'menu-label': menuLabel,
  'close-label': closeLabel,
  active,
  onToggleMenu,
  children,
}) => {
  const initialFocusRef = useRef();
  const Groups = React.Children.map(children, (child) =>
    child.type.displayName === 'Group' ? child : null,
  );

  const [activeGroup, setActiveGroup] = useState(
    React.Children.count(Groups) > 0 && Groups[0].key,
  );

  if (React.Children.count(Groups) === 0) {
    return null;
  }

  const Content = React.Children.map(Groups, (group) => {
    const collapsible = React.Children.count(Groups) > 1;
    const isActive = group.key === activeGroup;

    const onGroupSelect = () => {
      if (activeGroup === group.key) {
        setActiveGroup('');
      } else {
        setActiveGroup(group.key);
      }
    };

    return React.cloneElement(group, {
      active: isActive,
      collapsible,
      onGroupSelect: collapsible ? onGroupSelect : null,
      onNavigate: onToggleMenu,
    });
  });

  const Footer = React.Children.map(children, (child) =>
    child.type.displayName === 'Footer' ? child : null,
  );

  return (
    <>
      {!!active && (
        <div
          className="br-scrim-util foco active"
          aria-expanded="true"
          aria-label={closeLabel}
          {...accessibleOnClick(onToggleMenu)}
        />
      )}
      {active ? (
        <FocusTrap
          focusTrapOptions={{
            escapeDeactivates: true, // ⎋ ESC fecha
            onDeactivate: onToggleMenu, // chama seu fechar
            allowOutsideClick: true, // permite clique fora
            clickOutsideDeactivates: false,
            returnFocusOnDeactivate: true,
            initialFocus: () => initialFocusRef.current,
            preventScroll: true,
          }}
        >
          <nav className={styles.active} aria-label={menuLabel}>
            {/* {title && (
              <Header
                title={title}
                handleToggleMenu={onToggleMenu}
                closeLabel={closeLabel}
              />
            )} */}
            <button
              className={`br-button small circle ${styles.menuClose}`}
              onClick={onToggleMenu}
              ref={initialFocusRef}
              aria-expanded={active}
              aria-label="Fechar menu de navegação"
            >
              <i className="fas fa-times" aria-hidden="true" />
            </button>

            <div className={styles.content}>{Content}</div>

            {Footer}
          </nav>
        </FocusTrap>
      ) : (
        <nav className={styles.root} aria-label={menuLabel} inert="" />
      )}
    </>
  );
};

SiteNavigation.Group = Group;
SiteNavigation.Footer = Footer;

SiteNavigation.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  onToggleMenu: PropTypes.func,
  'menu-label': PropTypes.string,
  'close-label': PropTypes.string,
  children: PropTypes.node,
};

SiteNavigation.defaultProps = {
  'menu-label': 'Main navigation menu',
  'close-label': 'Close menu',
  active: false,
};

export default SiteNavigation;
